var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1562,
    height: 1055,
    viewBox: "0 0 1562 1055",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.71366L400.247 1050.67L410.693 1050.7L635.176 461.09L502.65 104.08C495.438 80.6399 470.646 21.548 418.807 12.1229C389.056 6.71384 318.393 3.81938 234.893 4.00874C152.926 4.19462 63.0568 4.03412 5 6.71366Z",
    fill: "#0096DA",
    stroke: "white",
    strokeWidth: 7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M410.696 1050.69L767.706 112.186C783.032 77.9277 824.503 9.41064 867.777 9.41064H1186.92C1253.64 11.2137 1426.09 42.7874 1516.89 231.189C1625.07 455.673 1495.25 642.291 1408.7 718.021C1405.82 720.54 1303.22 804.569 1132.83 804.569C962.439 804.569 948.915 791.046 908.346 880.298C867.777 969.55 859.663 1050.69 781.229 1050.69H410.696Z",
    fill: "#022C87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M410.696 1050.69L767.706 112.186C783.032 77.9277 824.503 9.41064 867.777 9.41064M410.696 1050.69C508.063 1050.69 718.482 1050.69 781.229 1050.69M410.696 1050.69H781.229M867.777 9.41064C911.051 9.41064 1098.57 9.41064 1186.92 9.41064M867.777 9.41064H1186.92M1186.92 9.41064C1253.64 11.2137 1426.09 42.7874 1516.89 231.189C1625.07 455.673 1495.25 642.291 1408.7 718.021C1405.82 720.54 1303.22 804.569 1132.83 804.569C962.439 804.569 948.915 791.046 908.346 880.298C867.777 969.55 859.663 1050.69 781.229 1050.69",
    stroke: "white",
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColor);
export default __webpack_public_path__ + "static/media/logoColor.6766a2903846068fbc13efab61a91a97.svg";
export { ForwardRef as ReactComponent };